import { render, staticRenderFns } from "./ProfileVerificationCodeModal.vue?vue&type=template&id=3646d8cd&"
import script from "./ProfileVerificationCodeModal.vue?vue&type=script&lang=js&"
export * from "./ProfileVerificationCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports